import domtoimage from 'dom-to-image';
import ToolsService from '@/providers/tools';

import { DesignerElement } from './models/designer-element.model';
import { IToolActionResponse } from './models/designer-tools.model';
import { DesignerElementTypes } from './designer.enum';

export class DesignerStateProvider {
  containerId = '';
  elements: DesignerElement[] = [];
  elementSelected: DesignerElement = null;
  quillTextInstance = null;
  quillTextToolbarId = `designer-text-toolbar-${Date.now()}`;
  quillIsHidden = false;
  quillIsReady = false;
  isTextOnPreRender = false;
  toolsDisabled = [];
  maxMBImageToImport: 0.2;
  containerHeight = 434;
  containerWidth = 700;

  setQuillInstance(instance) {
    this.quillTextInstance = instance;
  }

  setQuillToolbarId(id) {
    this.quillTextToolbarId = id;
  }

  async refreshToolbar() {
    this.quillIsHidden = true;
    this.quillIsReady = false;
    
    await ToolsService.sleep(20);
    this.quillIsHidden = false;
  }

  executeAction({ action }) {
    const { elementSelected }: IToolActionResponse = action({
      elements: this.elements,
      elementSelected: this.elementSelected,
    });

    this.elementSelected = elementSelected;
  }

  clearSelection() {
    this.elementSelected = null;
    this.quillIsReady = false;
    this.isTextOnPreRender = false;
  }

  setElementsFromJson(elements: any[]) {
    this.elements = elements.map(e => new DesignerElement(e));
    this.elementSelected = null;
  }

  async getImageDesign() {
    this.clearSelection();
    const container = document.getElementById(this.containerId);

    return domtoimage.toJpeg(container);
  }

  getElementsToSaveFormatted() {
    this.clearSelection();

    if (this.elements) {
      return this.elements.map(e => e.getElementToSaveFormatted());
    }
  }

  getDesignJson() {
    return {
      elements: this.getElementsToSaveFormatted(),
    }
  }

  addElement(type: DesignerElementTypes, meta?: any) {
    const element = new DesignerElement({ type, meta });
    
    this.elements.push(element);
    this.updateZPosition();
  }

  updateZPosition() {
    this.elements.forEach((e, i) => e.setZPosition(i));
  }
}